import React from 'react';
import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { Layout } from '@singularsystems/neo-canvas-grid';
import NegativePortfolioBookPriceReportCriteria from './NegativePortfolioBookPriceReportCriteria';
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { AppService, Types } from '../../../App/Services/AppService';
import { TextConstants } from '../../../Common/TextConstants';

@NeoReport("NegativePortfolioBookPrice", { category: MaintenanceReportCategories.DataValidationReports })
export default class NegativePortfolioBookPriceReport extends Report<NegativePortfolioBookPriceReportCriteria> {
    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient)
    ) {
        super(NegativePortfolioBookPriceReportCriteria);
    }

    public renderCriteria() {
        return <>
            <Neo.GridLayout lg={4}>
                <Neo.FormGroup bindContext={this.criteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                    <Neo.AutoCompleteDropDown
                        itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                        bind={this.criteria.meta.staticServiceProviderFileGroupingId}
                        bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                        displayMember={"serviceProviderGroupingName"}
                        items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data.slice(0, 10)
                            .sort((x, y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                    />
                </Neo.FormGroup>
                <Neo.FormGroup
                    label={TextConstants.Labels.ClientAccount}
                    bind={this.criteria.meta.brokerAccount}
                />
                <Neo.FormGroup
                    appendText="fa-calendar"
                    bind={this.criteria.meta.startDate} />
                <Neo.FormGroup
                    appendText="fa-calendar"
                    bind={this.criteria.meta.endDate} />
            </Neo.GridLayout>
        </>;
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}